import React from 'react'
import type { FC } from 'react'
import InstoreIdentificationContainer from '@/checkout-instore-legacy/components/Identification/IdentificationContainer'
import AppContainer from '@/checkout-instore-legacy/components/AppContainer'

export const Identification: FC = () => {
  return (
    <AppContainer>
      <InstoreIdentificationContainer />
    </AppContainer>
  )
}
